<template>
  <div>
    <div class="content">
      <b-container>
        <b-row align-h="between">
          <b-col cols="auto">
            <button @click="back()" class="icon-btn">
              <i class="material-icons md-36">arrow_back</i>
            </button>
          </b-col>
          <b-col cols="auto">
            <button @click="restart" class="icon-btn">
              <i class="material-icons md-36">refresh</i>
            </button>
            <button @click="finish" class="icon-btn">
              <i class="material-icons md-36">skip_next</i>
            </button>
          </b-col>
        </b-row>
      </b-container>
      <b-container>
        <b-row align-h="center">
          <b-col cols="auto">
            <h1 class="question title-sm mb-4">{{ quizData[page].question }}</h1>
          </b-col>
        </b-row>
        <b-row align-h="around">
          <b-col cols="auto" lg="4" v-for="(option, index) in quizData[page].options" :key="option">
            <tooltip :option="option"/>
            <b-button
              size="lg"
              @click="save(option)"
              :class="{ 'selected': $route.params.page == 6 && quizData[page].selected[index] }"
            >
              <h3>{{ option }}</h3>
            </b-button>
          </b-col>
        </b-row>
        <b-row align-h="between" v-if="$route.params.page == 6">
          <b-col align-self="end" class="text-right">
            <b-button class="icon-btn round-border" @click="finish">
              <h4 class="align-middle d-inline mr-2">Get Results</h4>

              <i class="material-icons md-36" style="vertical-align:middle">arrow_forward</i>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="progress footer">
      <div
        class="progress-bar"
        :style="'width: ' + ($route.params.page * 100 / 6) + '%;'"
        role="progressbar"
      ></div>
    </div>
  </div>
</template>

<style scoped>
.question {
  max-width: 800px;
}

.col-auto {
  padding: 15px;
}

.btn-lg {
  width: 275px;
  height: 120px;
}

.btn:hover,
.btn:active,
.btn.selected {
  background-color: rgb(118, 35, 106) !important;
}

.progress {
  border-radius: 0px;
}

.progress-bar {
  background-color: rgb(236, 0, 140);
}

.footer {
  position: fixed;
  bottom: 0px;
  width: 100%;
  height: 10px;
}
</style>

<script>
import Tooltip from '@/components/Tooltip.vue';

export default {
  props: ['page'],
  components: {
    Tooltip
  },
  beforeMount() {
    if (this.$route.params.page == 6) {
      let selectedOptions = JSON.parse(localStorage.getItem('selectedOptions'));
      let options = this.quizData[6].options;
      let props = this.quizData[6].propName;

      for (let option in options) {
        if (selectedOptions[props[options[option]]]) {
          this.$set(this.quizData[6].selected, option, selectedOptions[props[options[option]]]);
        }
      }
    } else if (this.$route.params.page === 1) {
      localStorage.setItem('selectedOptions', JSON.stringify({}));
    }
  },
  methods: {
    save(option) {
      let page = this.$route.params.page;
      let prop = this.quizData[page].propName;

      let options = JSON.parse(localStorage.getItem('selectedOptions'));
      if (options === null) options = {};

      if (page < 6) {
        options[prop] = option;
        this.next();
      } else {
        prop = prop[option];
        let index = this.quizData[page].options.indexOf(option);
        let toggle = options[prop] && options[prop] === true ? false : true;
        this.$set(this.quizData[page].selected, index, toggle);
        options[prop] = toggle;
      }
      localStorage.setItem('selectedOptions', JSON.stringify(options));
    },
    next() {
      if (this.$route.params.page < 6)
        this.$router.push({ name: 'quiz', params: { page: ++this.$route.params.page } });
      else {
        this.finish();
      }
    },
    restart() {
      this.$router.push({ name: 'home' });
      localStorage.clear();
    },
    back() {
      let page = this.$route.params.page;
      let propNames = [];

      if (this.$route.params.page == 6) {
        for (var key in this.quizData[page].propName) {
          // Push all key names
          propNames.push(this.quizData[6].propName[key]);
        }

        // Also push previous page
        propNames.push(this.quizData[5].propName);

        // Clear all selections
        this.$set(this.quizData[6], 'selected', [false, false, false, false, false, false]);
      } else {
        propNames.push(this.quizData[page - 1].propName);
      }

      let options = JSON.parse(localStorage.getItem('selectedOptions'));
      if (options === null) options = {};
      propNames.forEach(name => delete options[name]);

      localStorage.setItem('selectedOptions', JSON.stringify(options));

      this.$router.go(-1);
    },
    finish() {
      let opts = JSON.parse(localStorage.getItem('selectedOptions'));
      if (opts && opts.printFrom) {
        opts[opts.printFrom] = true;
        delete opts.printFrom;
      }
      if (opts && opts.printerType === 'No Preference') {
        delete opts.printerType;
      }
      localStorage.setItem('selectedOptions', JSON.stringify(opts));

      this.$router.push({ name: 'results' });
    }
  },
  data() {
    return {
      quizData: [
        {
          question: 'What will you use your printer for?',
          propName: 'printUse',
          options: ['Home/Personal', 'Work']
        },
        {
          question: 'How much will you be printing?',
          propName: 'printVolume',
          options: [
            'Less than 10 pages per week',
            'Between 10-50 pages per week',
            'Daily, or 50+ pages per week'
          ]
        },
        {
          question: 'What functions do you need?',
          propName: 'printFunctions',
          options: ['Just Printing', 'Print, Copy, Scan', 'Print, Copy, Scan, and Fax']
        },
        {
          question: 'What will you be printing?',
          propName: 'printAbility',
          options: ['Mainly Photographs and Images', 'Mainly Documents', 'Both']
        },
        {
          question: 'What size paper do you want to print on?',
          propName: 'paperSize',
          options: ['Up to A4', 'Up to A3']
        },
        {
          question: 'What type of printer would you prefer?',
          propName: 'printerType',
          options: ['Inkjet', 'Laser', 'No Preference']
        },
        {
          question: 'What other features would you want to use?',
          propName: {
            'Double Sided Printing': 'doubleSided',
            'Auto Document Feeder': 'autoDocument',
            'Multi Paper Trays': 'multiPaper',
            'Touch Screen': 'touchScreen',
            WiFi: 'wifi',
            'Cloud Printing': 'cloudBased'
          },
          options: [
            'Double Sided Printing',
            'Auto Document Feeder',
            'Multi Paper Trays',
            'Touch Screen',
            'WiFi',
            'Cloud Printing'
          ],
          selected: [false, false, false, false, false, false],
          selectMultiple: true
        }
      ]
    };
  }
};
</script>

